(() => {
  if (window.feelpatchCartSubscriptionUpgradeLoaded) return;
  window.feelpatchCartSubscriptionUpgradeLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-fp-subscribe]');
    if (!button) return;

    const line = Number(button.dataset.line);
    if (!Number.isInteger(line) || line < 1) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line,
          quantity: 1,
          selling_plan: 694789865819
        })
      });

      if (!response.ok) throw new Error('Cart subscription upgrade failed');
      window.location.reload();
    } catch (error) {
      button.textContent = button.dataset.error || originalText;
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  });
})();
